/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type verifyTempoTokenInput = {
    token?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type VerifyTempoTokenMutationVariables = {
    input: verifyTempoTokenInput;
};
export type VerifyTempoTokenMutationResponse = {
    readonly verifyTempoToken: {
        readonly statusCode: number | null;
        readonly worklogCount: number | null;
    } | null;
};
export type VerifyTempoTokenMutation = {
    readonly response: VerifyTempoTokenMutationResponse;
    readonly variables: VerifyTempoTokenMutationVariables;
};



/*
mutation VerifyTempoTokenMutation(
  $input: verifyTempoTokenInput!
) {
  verifyTempoToken(input: $input) {
    statusCode
    worklogCount
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "verifyTempoTokenInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "verifyTempoTokenPayload",
    "kind": "LinkedField",
    "name": "verifyTempoToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "worklogCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyTempoTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyTempoTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "VerifyTempoTokenMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyTempoTokenMutation(\n  $input: verifyTempoTokenInput!\n) {\n  verifyTempoToken(input: $input) {\n    statusCode\n    worklogCount\n  }\n}\n"
  }
};
})();
(node as any).hash = '4a196231780f6b993d4605548940ee59';
export default node;
